<template>
  <div style="max-width: 900px">
    <div class="row ">
<!--      <a class="btn btn-primary mybutton ml-auto" href="#" @click="queryItem(false)">查詢</a>-->
<!--      <a class="btn btn-primary mybutton" href="javascript:location.reload()" >清除搜尋</a>-->
      <a class="btn btn-info mybutton " href="#" @click="addItem">新增</a>
      <a class="btn btn-danger mybutton" href="#" @click="deleteItem">刪除</a>

      <a class="btn btn-info mybutton " href="#" @click="qrCodeGen">產生QRCode</a>
    </div>

    <MyGridEasyTable ref="grid" :datas.sync="gridDefine.datas" :columns="gridDefine.columns" :config="gridDefine.config"></MyGridEasyTable>
  </div>
</template>

<script>
import {
  QueryType_CheckIn_Index_1_Event,
} from "../js/checkInDeclare";
import MyGridEasyTable from "@/views/taylorAdmin/component/MyGridEasyTable";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import util from "@/util/util";
import apiCheckIn from "@/views/checkInAdmin/js/apiCheckIn";
/**

 **/

let editRouter="CheckInAdminEventEdit";

export default {
  components: {MyGridEasyTable},
  //name: "Index",
  // props: [""],
  data: function () {
    return {
      QueryType_CheckIn_Index_1_Event:QueryType_CheckIn_Index_1_Event,
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      gridDefine:{
        config:{
          showColumnSeq:true,
          showColumnCheckBox:true,
          showColumnRadio:false,
        },
        columns:[
          { field: "f", key: "fzz", title: "功能", align: "center" ,width:100, renderBodyCell:  this.renderFunctionButton},
          { field: "Name", key: "a", title: "活動名稱", align: "center" ,sortBy:""},
          { field: "Memo", key: "b", title: "備註", align: "left",sortBy:"" },
        ],
      },
    };
  },
  methods: {
    async loadData() {
      let data=await apiAdmin.getContentList(this.QueryType_CheckIn_Index_1_Event);
      this.gridDefine.datas=apiAdmin.initReturnArray(data.data.data);
      // this.$refs.grid.refreshTableData(this.gridDefine.datas);
      this.$refs.grid.datas=this.gridDefine.datas;
      this.$refs.grid.resetTableData();
    },
    renderFunctionButton({ row, column, rowIndex },h) {  // eslint-disable-line
      return (
          <a role="button" class="btn btn-primary" href='#' on-click={() => this.editItem(row, column, rowIndex)}>編輯</a>

      );
    },
    addItem(){
      this.$router.push({ name: editRouter, query: { type: this.QueryType_CheckIn_Index_1_Event,SystemId:"" } })
    },
    editItem (row, column, rowIndex) {// eslint-disable-line
      this.$router.push({ name: editRouter, query: { type: this.QueryType_CheckIn_Index_1_Event,SystemId:row.SystemId } });
    },
    deleteItem(){
      let ids=this.$refs.grid.getSelectedRowKeys();

      if (ids.length>0){
        if (confirm('確定刪除?')){
          apiAdmin.api_deleteContentBySystemIds(ids).then(()=>{
            this.loadData();
          });
        }
      }else{
        util.ShowMessage('請先選擇欲刪除的資料');
      }
    },
    qrCodeGen(){
      let ids=this.$refs.grid.getSelectedRowKeys();

      if (ids.length !==1){
        util.ShowMessage('請先選擇一個活動');
      }

      let loader=util.ShowLoading(this);

      apiCheckIn.api_Event_GenQRCode(ids[0]).then((result)=>{
        util.HideLoading(loader);

        apiCheckIn.api_Download(result.data.data);

      });
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>

</style>
